import React, { useEffect, useState } from "react";
import LanguageContext from "../../../helper/LanguageContext";
import {
  BRANCH_CATEGORY_I18N,
  BRANCH_ROLE_I18N,
  COMPANY_BRANCH_CATEGORY_I18N,
  COMPANY_BRANCH_I18N,
  localizeBranchLabel,
  normalizeBranchLang,
} from "../../../Languages/vars/branchI18n";
import "./CompanyRolesDropDown.css";

const getItemLabel = (item, lang) => {
  if (!item) return "";
  const key = item.name_en;
  if (
    key &&
    (BRANCH_ROLE_I18N[key] ||
      COMPANY_BRANCH_I18N[key] ||
      BRANCH_CATEGORY_I18N[key] ||
      COMPANY_BRANCH_CATEGORY_I18N[key])
  ) {
    return localizeBranchLabel(key, lang);
  }
  return lang === "de"
    ? item.name_de || item.name_en || ""
    : item.name_en || item.name_de || "";
};

function CompanyRolesDropDown(props) {
  const { isGerm, strings, language } = React.useContext(LanguageContext);
  const lang = normalizeBranchLang(language || (isGerm ? "de" : "en"));
  const [display, setDisplay] = useState(null);
  const [search, setSearch] = useState("");
  const handleClass = (index) => {
    console.log(display);
    if (display === index) {
      setDisplay(null);
    } else {
      setDisplay(index);
    }
  };
  const [selectRoles, setSelectRoles] = useState([]);

  const [positions, setPositions] = useState(props.position);
  const allPositions = props.position;
  const sendRoles = (tmp) => {
    let onlySelected = [];
    for (let obj of tmp) {
      let ONL = obj.branches.filter((e) => e.isSelected);
      onlySelected = [...onlySelected, ...ONL];
    }
    props.selectPosition(onlySelected);
  };

  const searchRole = async (text) => {
    setSearch(text);
    console.log(typeof text);

    if (text !== "") {
      let filterPositions = allPositions;
      const q = text.toLowerCase();
      let positionIndex = await positions.findIndex(
        (item) => getItemLabel(item, lang)?.toLowerCase() == q
      );

      if (positionIndex !== -1) {
        console.log(positionIndex);
        filterPositions = [allPositions[positionIndex]];
        console.log(filterPositions);
        setDisplay(null);
      } else {
        filterPositions = await allPositions.map((item) => {
          console.log(positionIndex);
          let filterRoles = item.branches.filter((i) => {
            const localized = getItemLabel(i, lang);
            return (
              localized?.toLowerCase().includes(q) ||
              i.name_en?.toLowerCase().includes(q) ||
              i.name_de?.toLowerCase().includes(q)
            );
          });
          return { ...item, branches: filterRoles };
        });
        filterPositions = filterPositions.filter(
          (position) => position.branches.length > 0
        );
        if (filterPositions.length > 0) {
          setDisplay(filterPositions[0].id);
          console.log(filterPositions[0].id);
        }
      }
      setPositions(filterPositions);
    } else {
      setDisplay(null);
      setPositions(allPositions);
    }
  };

  const addRoles = async (value, RL, mainIndex, subIndex) => {
    let tmp = [...positions];
    tmp[mainIndex].branches[subIndex].isSelected =
      !tmp[mainIndex].branches[subIndex].isSelected;
    setPositions([...tmp]);
    sendRoles(tmp);
  };
  useEffect(() => {
    searchRole(props.searchVal);
  }, [props.searchVal, lang]);
  useEffect(() => {
    let tmp = [...positions];
    for (let obj of tmp) {
      for (let objx of obj.branches) {
        objx.isSelected = false;
      }
    }
    setPositions([...tmp]);
  }, [props.position]);
  return (
    <div className="company-roles-dropdown">
      {positions &&
        positions.map((position, index) => (
          <div key={position.id || index}>
            <div>
              {position.branches.map((roles, key) => (
                <label
                  key={key}
                  className="role-label company-roles-dropdown__label"
                >
                  <i>{getItemLabel(roles, lang)}</i>
                  <input
                    value={roles.name_en}
                    onChange={(e) => {
                      addRoles(e.target.value, roles, index, key);
                    }}
                    type="checkbox"
                  />
                  <span className="checkmark-label" />
                </label>
              ))}
            </div>
          </div>
        ))}
      {positions.length <= 0 && (
        <div className="text-center company-roles-dropdown__empty">
          <p className="text-muted company-roles-dropdown__empty-text">
            No Match Record Found!
          </p>
        </div>
      )}
      <div
        className="bottom-button"
        onClick={() => {
          props.hideRoles();
        }}
      >
        <a
          className="kj-btn kj-btn--outline kj-btn--on-surface"
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          {strings.confirm}
        </a>
      </div>
    </div>
  );
}

export default CompanyRolesDropDown;
